import { useBoxSlotFormikUpdate } from "@/modules/boxSlot/hooks/useBoxSlotFormik"
import { BoxSlotFormView } from "@/modules/boxSlot/components/boxSlotFormView"
import { useBoxSlotDetails } from "@/modules/boxSlot/hooks/useBoxSlotDetails"

type BoxSlotFormUpdateProps = {
  boxSlotId: string
  className?: string
} & React.ComponentProps<"div">
export function BoxSlotFormUpdate({ boxSlotId, className, ...props }: BoxSlotFormUpdateProps) {
  const formik = useBoxSlotFormikUpdate(boxSlotId)
  const { data: boxSlot } = useBoxSlotDetails(boxSlotId)

  return <BoxSlotFormView formik={formik} boxSlot={boxSlot} hideTitle={true} className={className} {...props} />
}
